import React from "react";

import PricingSection from "./PricingSection";
import QueryButton from "../query/QueryButton";


const ProductOverview = ({
  overview,
}) => {

  return (
    <div className="product-overview">

      {/* HERO */}

      <section className="product-overview-hero">

        <div className="product-overview-hero-content">

          <div className="product-category">

            {overview.category?.name}

          </div>


          <h1>
            {overview.name}
          </h1>


          {overview.shortDescription && (
            <p className="product-short-description">
              {overview.shortDescription}
            </p>
          )}


          {/* QUERY */}

          <QueryButton
            offering={overview}
          />

        </div>


        <div className="product-overview-hero-image">

          {overview.image?.url ? (

            <img
              src={overview.image.url}
              alt={
                overview.image.altText ||
                overview.name
              }
            />

          ) : (

            <div className="product-image-placeholder">
              {overview.name}
            </div>

          )}

        </div>

      </section>


      {/* DESCRIPTION */}

      <section className="product-description-section">

        <div className="product-description">

          <h2>
            About {overview.name}
          </h2>


          <div
            className="product-description-content"
            dangerouslySetInnerHTML={{
              __html:
                overview.description || "",
            }}
          />

        </div>

      </section>


      {/* PRICING */}

      {overview.pricingPlans?.length > 0 && (

        <PricingSection
          pricingPlans={
            overview.pricingPlans
          }
        />

      )}


      {/* CTA */}

      <section className="product-overview-cta">

        <div>

          <h2>
            Interested in {overview.name}?
          </h2>


          <p>
            Get in touch with our team to
            discuss your requirements.
          </p>

        </div>


        {/* QUERY */}

        <QueryButton
          offering={overview}
        />

      </section>

    </div>
  );
};


export default ProductOverview;